import { CustomerLogo } from '@sequencehq/core-components'
import { useQuery } from '@sequencehq/api'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'
import { MINUTES } from '@sequencehq/utils/dates'

import { getLogoSrc } from 'Customer/utils/logo'

/**
 * The invoice's customer logo, resolved from the customer's domain. The invoice
 * snapshot carries the customer id but not the domain, so the customer is fetched
 * by id (cached and shared across the list row, preview header and review modal).
 * `CustomerLogo` renders a neutral fallback until it resolves or when the customer
 * has no logo-able domain.
 */
export const InvoiceReviewCustomerLogo = ({
  customerId,
  size = 24,
  fallbackSize = 16,
  'data-testid': dataTestId
}: {
  customerId: string
  size?: number
  fallbackSize?: number
  'data-testid'?: string
}) => {
  const { data: customer } = useQuery(
    dashboardv99990101Client.getCustomer,
    { id: customerId },
    { enabled: !!customerId, staleTime: 5 * MINUTES }
  )

  return (
    <CustomerLogo
      src={customer ? getLogoSrc(customer) : undefined}
      size={size}
      fallbackSize={fallbackSize}
      data-testid={dataTestId}
    />
  )
}
